import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

const CreaEquipos = () => {
  const [postNombre, setPostNombre] = useState([]);
  const [postCodigo, setPostCodigo] = useState([]);

  const [postFecha, setPostFecha] = useState([]);
  const [postMarca, setPostMarca] = useState([]);
  const [postCapacidad, setPostCapacidad] = useState([]);
  const [postPrueba, setPostPrueba] = useState([]);
  const [postUprueba, setPostUprueba] = useState([]);

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://inspecciongnvback.azurewebsites.net/api/v1/CreaEquipos",
      data: {
        nombre: postNombre,
        codigo: postCodigo,
        fecha: postFecha,
        marca: postMarca,
        capacidad: postCapacidad,
        prueba: postPrueba,
        ultimaPrueba: postUprueba,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert(" creada con exito!");
        window.location.href = "/admin/AsignaEquipo/" + Response.data;
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear " + error);
      });
  };

  return (
    <>
      {/* Page content */}
      <button
        variant="contained"
        className="btn btn-primary btn-lg"
        color="primary"
        onClick={handleOpenModalTest}
      >
        Nuevo
      </button>
      <ReactModal isOpen={modalIsOpen} onRequestClose={closeModal}>
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">My account</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Settings
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      Generar Orden de Servicio
                    </h6>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Nombre
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-username"
                              placeholder=""
                              type="text"
                              onChange={(e) => setPostNombre(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Codigo
                            </label>
                            <Input
                              className="form-control-alternative"
                              id=""
                              type="text"
                              onChange={(e) => setPostCodigo(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-first-name"
                            >
                              Fecha Fabricacion
                            </label>
                            <Input
                              className="form-control-alternative"
                              defaultValue="Lucky"
                              id="input-first-name"
                              placeholder=""
                              onChange={(e) => setPostFecha(e.target.value)}
                              type="date"
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              Marca
                            </label>
                            <Input
                              className="form-control-alternative"
                              defaultValue=""
                              id="input-last-name"
                              placeholder=""
                              onChange={(e) => setPostMarca(e.target.value)}
                              type="text"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    <hr className="my-4" />
                    {/* Address */}
                    <h6 className="heading-small text-muted mb-4">Serial</h6>
                    <div className="pl-lg-4">
                      <Row>
                        <Col md="12">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-address"
                            >
                              Capacidad
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-address"
                              placeholder=""
                              onChange={(e) => setPostMarca(e.target.value)}
                              type="text"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-city"
                            >
                              Prueba
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-city"
                              placeholder=""
                              onChange={(e) => setPostPrueba(e.target.value)}
                              type="text"
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-country"
                            >
                              Ultima Prueba
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-country"
                              placeholder=""
                              onChange={(e) => setPostUprueba(e.target.value)}
                              type="text"
                            />
                          </FormGroup>
                          <button
                            variant="contained"
                            className="btn btn-primary btn-lg"
                            color="primary"
                            onClick={postData}
                          >
                            Guardar
                          </button>
                        </Col>
                      </Row>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default CreaEquipos;
